import * as z from 'zod';

export const upgradeSubscriptionSchema = z.object({
  priceId: z.string().min(1, { message: 'priceId is required.' }),
});

export type UpgradeSubscriptionRequest = z.infer<typeof upgradeSubscriptionSchema>;

